import React, { Component } from 'react'

import { Box, Button, Card, CardContent, Chip } from '@mui/material'
import queryString from 'query-string'
import { connect } from 'react-redux'
import type { RootState } from 'reducers'
import { UrlProvider } from 'urls'

import { login, me } from 'actions/auth-actions'
import { FormTextField } from 'components/input'
import { withForm } from 'decorators/withForm'
import { loginValidator } from 'validators/auth'

type LoginProps = {
  handleSubmit: (...args: any[]) => any
  hasError: boolean
  hasFailed: boolean
  location: Record<string, any>
  login: (...args: any[]) => any
  me: (...args: any[]) => any
  navigate: (...args: any[]) => any
  submitting: boolean
}

type LoginState = {
  invalidCredentials: boolean
}

class Login extends Component<LoginProps, LoginState> {
  state: LoginState = { invalidCredentials: false }

  onSubmit = async (values: any) => {
    const { location, login, navigate, me } = this.props
    this.setState({ invalidCredentials: false })
    const res = await login(values)
    const {
      payload: { body, error },
    } = res
    // Any login failure stops here (don't fall through to me()/navigate); errors surface via the reducer's hasFailed.
    if (error) {
      this.setState({ invalidCredentials: error.status === 401 })
      return
    }

    // eslint-disable-next-line camelcase
    const { mfa_required } = body || {}
    // eslint-disable-next-line camelcase
    if (mfa_required) {
      return navigate({
        pathname: UrlProvider.getUrl('login.mfa'),
        search: location.search,
      })
    }
    await me()
    navigate(queryString.parse(location.search).next || '/')
  }

  renderErrorMessage = () => {
    const { hasError, hasFailed } = this.props
    const { invalidCredentials } = this.state

    if (invalidCredentials) return <Chip label="Invalid email/password" sx={{ mb: '1rem' }} />
    if (hasError) return <Chip label="give it another go" sx={{ mb: '1rem' }} />
    if (hasFailed) return <Chip label="server error :(" sx={{ mb: '1rem' }} />
  }

  render() {
    return (
      <Box className="container container--narrow" sx={{ '& .form-text-field': { mb: '1rem' } }}>
        <Card>
          <CardContent>
            {this.renderErrorMessage()}
            <form onSubmit={this.props.handleSubmit(this.onSubmit)}>
              <FormTextField fullWidth label="E-mail" name="email" variant="outlined" />
              <FormTextField fullWidth label="Password" name="password" type="password" variant="outlined" />
              <Button color="primary" fullWidth loading={this.props.submitting} type="submit" variant="outlined">
                Login
              </Button>
            </form>
          </CardContent>
        </Card>
      </Box>
    )
  }
}

export default connect(
  (s: RootState) => ({
    hasError: s.auth.hasError,
    hasFailed: s.auth.hasFailed,
    submitting: s.auth.submitting,
  }),
  { login, me },
)(
  withForm({
    form: 'loginForm',
    validate: loginValidator,
  })(Login),
)
